import $ from 'jquery';

$(document).ready(async () => {


	//Check if archive page, before loading resources
	const archivePageElement = document.querySelector('.archive-pages');
	if (archivePageElement) {

		/**
		 * Load select2 and set the placeholders
		 */
		try {
			//Wait for the async loading of select2
			import(
				/* webpackChunkName: "select2" */
				"select2"
				).then(async () => {

					$('#select_pr_categories').select2({
						placeholder: 'Category',
					});

					$('#select_pr_industries').select2({
						placeholder: 'Industry',
					});

					$('#select_pr_terms').select2({
						placeholder: 'Terms',
					});

					$('#select_pr_partners').select2({
						placeholder: 'Partners',
					});

					$('#select_pr_services').select2({
						placeholder: 'Services',
					});

					$('#select_pr_years').select2({
						placeholder: 'Years',
					});


					/**
					 * Load the archive short code custom methods.
					 */
					try {
						await import(/* webpackChunkName: "archive-filter-toggle" */'./archive-filter-toggle');
						await import(/* webpackChunkName: "filters" */'./legacy/filters');
						await import(/* webpackChunkName: "expands" */'./legacy/expands');
						await import(/* webpackChunkName: "archive-short-code" */'./legacy/archiveShortCode');
					} catch (err) {
						console.warn(err, 'Missing archive page custom js code');
					}
			});


		} catch (e) {
			console.warn('select2 not loaded')
		}
	} else {
		console.log('not archive page, resources not loaded');
	}

})
